import { render, staticRenderFns } from "./RegHotelListItem.vue?vue&type=template&id=a80b5f5e&scoped=true&"
import script from "./RegHotelListItem.vue?vue&type=script&lang=js&"
export * from "./RegHotelListItem.vue?vue&type=script&lang=js&"
import style0 from "./RegHotelListItem.vue?vue&type=style&index=0&id=a80b5f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80b5f5e",
  null
  
)

export default component.exports